<template>
    <div class="form-control" :class="{'has-error': validation.hasError('mirror')}">
        <div class="input-group input-group-sm">
            <datepicker ref="programaticOpen" :format="format" :value="modelo.fecha" @input="fechaSelect" :typeable="true" :clear-button="true" :language="espanol" placeholder="Formato DD/MM/YYYY"></datepicker>
        </div>
        <div class="error" v-if="validation.hasError('mirror')"> {{validation.firstError('mirror')}} </div>
        <!-- <small> {{mirror}} </small>  -->
    </div>
</template>

<style lang="css">
input[autocomplete="off"]{
    width: 90%;
}
input[placeholder="Formato DD/MM/YYYY"]:focus{
    outline: none;
}
</style>

<script>
//import Datepicker from 'vuejs-datepicker'
import Datepicker from '@hokify/vuejs-datepicker';
import { Validator } from 'simple-vue-validator';
import "@hokify/vuejs-datepicker/dist/vuejs-datepicker.css"; // include CSS
//import {mask} from 'vue-the-mask'
export default {
    props:{ 
        model:Object,valueto:{type:String,required:false,default:null },
        default:{type:String,required:false,default:null},
        datenewrest:{type:Boolean,required:false,default:false}, // para indicar que la fecha es en formato: dd/mm/yyyy
    },
    data(){
        return{
            espanol: 'es',
            format: "DD/MM/YYYY",
            mirror: null, // permite validar la fecha, pero no es la que se usa
            datos: [],
            modelo: {
                fecha: null,
            }
        }
    },
    //directives: {mask}, // default uncoment
    components:{Datepicker},
    watch:{
       /* 'modelo.fecha': function(a){
            if(a==null) return;
            var partes = a.split("/");
            var fec = partes[2]+"-"+partes[1]+"-"+partes[0];
            window.console.log( "FECHA::: ",fec )
            if( this.valueto != null ) this.model[this.valueto] = fec;
            else this.model.fecha = fec;
        },*/
        'default': function(){
            //window.console.log( "DEFAULTTTTT ",this.default );
            this.parseDefault();
        },
    },
    validators: {
        'modelo.fecha'(value){
            return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
        },
        'mirror'(value){
            if( this.datenewrest ) return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
            else return Validator.value(value).regex('^[0-9]{4}-[0-9]{2}-[0-9]{2}$'); // al server anio-mes-dia
        }
    },
    methods:{
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        customFormatter(date) {
            return this.$moment(date).format('dd/MM/yyyy');
        },
        fechaSelect(dat){
            var date = dat;
            if( !date ) return;
            var d = date.getDate();
            var m = date.getMonth()+1;
            var a = date.getFullYear();
            // window.console.log('fechaaaa', a);
            // if(a <= 1900) return;
            if( d < 10 ) d = '0'+d;
            if( m < 10 ) m = '0'+m;
            var fec = a+"-"+m+"-"+d;
            if( this.datenewrest ){
                fec = d+"/"+m+"/"+a;
            }
            // window.console.log( "fechaSelect ",fec );
            if( this.valueto ) this.model[this.valueto] = fec;
            else this.model.fecha = fec;
            this.mirror = fec; // para mostrar la fecha 
        },
        parseDefault(){
            //window.console.log( "XPRINT DEFAULT: >> ",this.default )
            if( this.default ) {
                //window.console.log( "PRINT DEFAULT: ",this.default )
                var ps = this.default.split("-");
                var def = ps[1]+"/"+ps[2]+"/"+ps[0];
                this.modelo.fecha = def;
                var fec = ps[0]+"-"+ps[1]+"-"+ps[2];
                if( this.datenewrest ){
                    fec = ps[2]+"/"+ps[1]+"/"+ps[0];
                }

                if( this.valueto ) this.model[this.valueto] = fec;
                else this.model.fecha = fec;
                //window.console.log( "XPRINT DEFAULT: >> ",def )
                //window.console.log( "DEFAULT FECHA: "+def )
            }
        },

        findFn(fec){
            window.console.log('-------------', fec);
            this.modelo.fecha = fec;
        }
    },
    mounted(){
        //this.modelo.fecha = new Date(2016, 9,  16);
        this.$validate().then(() => {  });        
        this.parseDefault();
    }
}
</script>